import { render, staticRenderFns } from "./magnifyGlass.vue?vue&type=template&id=475ad1f2&scoped=true&"
import script from "./magnifyGlass.vue?vue&type=script&lang=js&"
export * from "./magnifyGlass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475ad1f2",
  null
  
)

export default component.exports